var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg49(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 22,
    viewBox: "0 0 32 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.615234,
    width: 30.4615,
    height: 22,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_26_11785",
    transform: "translate(-0.101852) scale(0.00100309 0.00138889)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_26_11785",
    width: 1200,
    height: 720,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABLAAAALQAgMAAAD9a2E8AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAADFBMVEUAAADdAAD/zgD///9i/kqcAAAAAWJLR0QDEQxM8gAAAAd0SU1FB+EICgkYL2gaV60AAAKVSURBVHja7dBBAQAABAQwJZWUUoV7s0VYFQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPBeE5MlS5YsWbKQJUuWLFmykCVLlixZspAlS5YsWbKQJUuWLFmykCVLlixZspAlS5YsWbKQJUuWLFmykCVLlixZspAlS5YsWbKQJUuWLFmykCVLlixZspAlS5YsWbKQJUuWLFmykCVLlixZspAlS5YsWbKQJUuWLFmykCVLlixZspAlS5YsWbKQJUuWLFmykCVLlixZspAlS5YsWbKQJUuWLFmykCVLlixZspAlS5YsWbKQJUuWLFmykCVLlixZspAlS5YsWbKQJUuWLFmykCVLlixZspAlS5YsWbKQJUuWLFmykCVLlixZspAlS5YsWbKQJUuWLFmykCVLlixZspAlS5YsWbKQJUuWLFmykCVLlixZspAlS5YsWVezhpgsWbJkyZKFLFmyZMmShSxZsmTJkoUsWbJkyZKFLFmyZMmShSxZsmTJkoUsWbJkyZKFLFmyZMmShSxZsmTJkoUsWbJkyZKFLFmyZMmShSxZsmTJkoUsWbJkyZKFLFmyZMmShSxZsmTJkoUsWbJkyZKFLFmyZMmShSxZsmTJkoUsWbJkyZKFLFmyZMmShSxZsmTJkoUsWbJkyZKFLFmyZMmShSxZsmTJkoUsWbJkyZKFLFmyZMmShSxZsmTJkoUsWbJkyZKFLFmyZMmShSxZsmTJkoUsWbJkyZKFLFmyZMmShSxZsmTJkoUsWbJkyZKFLFmyZMmShSxZsmTJkoUsWbJkyZKFLFmyZMmShSxZsmTJkoUsWbJkyTpqAZ0gNym2ewUSAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE3LTA4LTEwVDA5OjI0OjQ2KzAwOjAwoC+f2gAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxNy0wOC0xMFQwOToyNDo0NiswMDowMNFyJ2YAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg49);
export default __webpack_public_path__ + "static/media/+49.913887435a98f97f00e794a2f980938b.svg";
export { ForwardRef as ReactComponent };